<template>
  <div :class="['col-xs-12', `col-md-${size}`]">
    <form-group-search-select-multiple
      v-if="disciplinas"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="disciplinas"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-disciplina-multipla",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    size: {
      type: String,
      default: "6"
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: Array,
    required: Boolean,
    protocolo: Object,
    cursoId: null,
    isRaNecessary: {
        type: Boolean,
        default: false
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  asyncComputed: {
    disciplinas() {
      let curso = this.formValues.cursoId;
      if (curso) {
        const cursoService = new CursoService(this.$http);
        let ra = null;
        if(this.isRaNecessary){
          ra = this.usuario.login;
        }
        return cursoService
          .getDisciplinasCurso(curso, null, ra)
          .then(result => {
            return result.map(disciplina => ({
              value: disciplina.CODDISC,
              text: disciplina.NOME
            }));
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/DisciplinaMultipla.vue